<label class="relative inline-block w-14 h-8" [ngClass]="[isDisabled ? 'hover:cursor-not-allowed' : '']">
    <input type="checkbox" class="hidden peer" [checked]="toggleButton" (change)="onToggle()" [disabled]="isDisabled" />
    <span class=" absolute inset-0 bg-border rounded-full peer-checked:bg-border transition duration-300"></span>
    <span
        class="absolute left-1 top-1 w-6 h-6 text-border bg-white rounded-full shadow transition duration-300 flex items-center justify-center peer-checked:translate-x-6 peer-checked:text-primary peer-checked:bg-primary">
        <span class="font-bold select-none">X</span>
    </span>
</label>